import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import getProjectId from 'utils/url/getProjectId';
import getProjectState from 'store/getProjectState';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';
import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunEntry from 'types/IRunEntry';

function setRunsAsync(
  projectId: string,
  runsAsync: IAsync<IPaginatedResponse<IRunEntry>>,
) {
  setProjectState(projectId, (state: IProjectState) => {
    return {
      ...state,
      runsAsync,
    };
  });
}

export default function fetchRuns(params?: {
  page?: number;
  pageSize?: number;
  search?: string;
}) {
  const projectId = getProjectId();
  if (!projectId) return;

  const async = getProjectState(store.getState(), projectId).runsAsync;

  switch (async.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setRunsAsync(projectId, { status: 'PENDING' });
      break;
    case 'SUCCESS':
      setRunsAsync(projectId, { status: 'REFRESH', data: async.data });
      break;
  }

  const searchParams = new URLSearchParams();
  if (params?.page) searchParams.set('page', String(params.page));
  if (params?.pageSize) searchParams.set('page_size', String(params.pageSize));
  if (params?.search) searchParams.set('search', params.search);

  const qs = searchParams.toString();
  const url = `projects/${projectId}/workflows${qs ? `?${qs}` : ''}`;

  api
    .get(url)
    .json()
    .then(
      (data) => {
        setRunsAsync(projectId, {
          status: 'SUCCESS',
          data: data as IPaginatedResponse<IRunEntry>,
        });
      },
      (error) => {
        Sentry.captureException(error);
        setRunsAsync(projectId, { status: 'ERROR' });
      },
    );
}
